export const animations = {
    'subtle-bounce-up': {
        value: 'subtleBounceUp 0.75s ease-in-out infinite',
    },
};
